import React from 'react';
import { FileText } from 'lucide-react';

export default function MetaCallToAction() {
  const scrollToGenerator = () => {
    document.getElementById('meta-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-emerald-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex justify-center mb-6">
          <FileText className="w-12 h-12 text-emerald-200" />
        </div>
        <h2 className="text-3xl font-bold text-white mb-4">
          Ready to Optimize Your Meta Titles?
        </h2>
        <p className="text-xl text-emerald-100 mb-8">
          Join thousands of website owners who use our AI-powered generator to create SEO-friendly meta titles.
        </p>
        <button 
          onClick={scrollToGenerator}
          className="bg-white text-emerald-600 text-lg px-8 py-4 rounded-lg hover:bg-emerald-50 transition-colors cursor-pointer shadow-lg hover:shadow-xl"
        >
          Generate Meta Titles Now!
        </button>
        <p className="mt-6 text-sm text-emerald-200">
          Perfect for websites, blogs, and e-commerce pages
        </p>
      </div>
    </section>
  );
}